module.exports = __webpack_public_path__ + "img/checkicon.cfea92c8.png";